import { Grid } from '@mui/material';

import { Typography, HelpTip } from '@occc/ui-design-system';
import {
  ProductGroupSelectField,
  MakeFilter,
  defaultMakeFilter,
  FuelRollbackAmountField,
} from '@occc-app/design-system';
import { Product_Group_Key } from '@occc/graphql';

const makeFilter: MakeFilter = (chainId, selectedProductGroup, selectedProductGroupIds) => {
  const defaultFilter = defaultMakeFilter(chainId, selectedProductGroup, selectedProductGroupIds);
  defaultFilter.keyEquals = Product_Group_Key.FuelGradeId;
  return defaultFilter;
};

export const FuelRollbackConfiguration = () => {
  return (
    <Grid container spacing={3}>
      <Grid item>
        <Typography variant='subtitle1' paragraph>
          Give Members:
        </Typography>
        <FuelRollbackAmountField name='fuelRollback.moneyAmount' />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='subtitle1' gutterBottom>
          On the following Fuel Grade Product Groups:
        </Typography>
        <ProductGroupSelectField
          inputProps={{
            margin: 'none',
          }}
          name='fuelRollback.eligibleProductGroups'
          label='Product groups'
          makeFilter={makeFilter}
        />
      </Grid>
      <Grid item xs={12}>
        <HelpTip title='Fuel Grade Product Groups'>
          <Typography variant='body2' color='textSecondary'>
            To create Fuel Rollback promotions, you must configure Fuel Grade product groups.
          </Typography>
        </HelpTip>
      </Grid>
    </Grid>
  );
};
